export default __webpack_public_path__ + "static/card-3-3a07f89d1171f7d1fd6daa307cd1fc19.svg";